module.exports = __webpack_public_path__ + "./images/7326296d907ef3e6f62d4d278a9ccbae.webp";